import { render, staticRenderFns } from "./Linkit.vue?vue&type=template&id=26152b3f&scoped=true"
import script from "./Linkit.vue?vue&type=script&lang=js"
export * from "./Linkit.vue?vue&type=script&lang=js"
import style0 from "./Linkit.vue?vue&type=style&index=0&id=26152b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26152b3f",
  null
  
)

export default component.exports